import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { WA_LINK_TYPE } from '@constants/campaignTemplates';
import { useTranslation } from './useTranslation';

export const useWhatsAppBusinessTemplates = () => {
    const templates = useSelector(state => state.channels.whatsAppBusinessTemplates);
    const { t } = useTranslation();

    const mapTemplatePropsToOption = template => ({
        value: template.templateId,
        label: template.name,
        disabled: !template.isValid,
        tooltip: template.isValid ? '' : t('apiErrors.invalidWhatsAppTemplate'),
    });

    const defaultFilterParams = {
        hasButtons: false,
    };

    const getWhatsAppBusinessTemplatesOptionsByChannel = useCallback(
        (channelId, filterParams = defaultFilterParams) => {
            return templates
                .filter(s => {
                    if (!s.channels.includes(channelId)) return false;
                    if (filterParams.hasButtons !== s.hasButtons) return false;
                    if (filterParams.hasButtons && s.linkType === WA_LINK_TYPE.COUPON) return false;
                    return true;
                })
                .map(mapTemplatePropsToOption);
        },
        [templates, t],
    );

    return {
        getWhatsAppBusinessTemplatesOptionsByChannel,
    };
};
